import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateNotificationInput,
    Notification,
    UpdateNotificationInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class NotificationsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listNotifications(): Promise<Notification[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listNotifications
                })
            ).data.listNotifications.items;
            if (data) return data as Notification[];
        } catch (error) {
            // console.error('Error finding Notification:', error);
            return null;
        }
    }

    async notificationsByStatus(status: string): Promise<Notification[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.NotificationsByStatus,
                    variables: {
                        status
                    }
                })
            ).data.NotificationsByStatus.items;
            if (data) return data as Notification[];
        } catch (error) {
            // console.error('Error finding Notification:', error);
            return null;
        }
    }
    async notificationsByReceipent(
        receipentEmail: string
    ): Promise<Notification[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.NotificationsByReceipent,
                    variables: {
                        receipentEmail
                    }
                })
            ).data.NotificationsByReceipent.items;
            if (data) return data as Notification[];
        } catch (error) {
            // console.error('Error finding Notification:', error);
            return null;
        }
    }
    async createNotifications(
        input: CreateNotificationInput
    ): Promise<Notification> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createNotification,
                    variables: {
                        input
                    }
                })
            ).data.createNotification;
            if (date) return date as Notification;
        } catch (error) {
            // console.error('Error creating NotificationRoles:', error);
            return null;
        }
    }
    async updateNotifications(
        input: UpdateNotificationInput
    ): Promise<Notification> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateNotification,
                    variables: {
                        input
                    }
                })
            ).data.updateNotification;
            if (date) return date as Notification;
        } catch (error) {
            // console.error('Error update NotificationRoles:', error);
            return null;
        }
    }
}
